import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	channelIsOn: {
		id: 'servicedesk.channels-jsd.channels.widget.channel-is-on',
		defaultMessage: 'Widget is on',
		description: 'Widget base for Message turned on/off channel',
	},
	channelTurnedOff: {
		id: 'servicedesk.channels-jsd.channels.widget.channel-turned-off',
		defaultMessage: 'Turned off',
		description: 'Turned part of Message of a turned off channel',
	},
	configure: {
		id: 'servicedesk.channels-jsd.channels.widget.configure',
		defaultMessage: 'Configure',
		description: 'Configure a channel',
	},
	configureLabelDescriptive: {
		id: 'servicedesk.channels-jsd.channels.widget.configure.label-descriptive',
		defaultMessage: 'Configure Widget',
		description: 'Configure a Widget',
	},
	widgetOnLabel: {
		id: 'servicedesk.channels-jsd.channels.widget.widget-on-label',
		defaultMessage: 'ENABLED',
		description: 'widget status label, shows as a lozenge on the nav',
	},
	widgetOffLabel: {
		id: 'servicedesk.channels-jsd.channels.widget.widget-off-label',
		defaultMessage: 'OFF',
		description: 'widget status label, shows as a lozenge on the nav',
	},
	widgetLabel: {
		id: 'servicedesk.channels-jsd.channels.widget.widget-label',
		defaultMessage: 'WIDGET',
		description: 'widget label',
	},
	widgetOn: {
		id: 'servicedesk.channels-jsd.channels.widget.widget-on',
		defaultMessage: 'On',
		description: 'widget config status label',
	},
	widgetOff: {
		id: 'servicedesk.channels-jsd.channels.widget.widget-off',
		defaultMessage: 'Off',
		description: 'widget config status label',
	},
	widget: {
		id: 'servicedesk.channels-jsd.channels.widget.widget',
		defaultMessage: 'Widget',
		description: 'widget label',
	},
});
